var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00A8D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.118 10.6594V9.58106H9.77962C10.8877 9.58106 11.4418 9.30431 11.4418 8.75081V5.84606C11.4418 5.29312 10.8877 5.01638 9.77962 5.01638H7.12125V6.759H5.625V3.9375H9.61313C11.8294 3.9375 12.9375 4.54613 12.9375 5.76338V8.83406C12.9375 10.0513 11.8294 10.6599 9.61313 10.6599L8.118 10.6594ZM11.4418 11.3237H12.9375V12.2366C12.9375 13.4539 11.8294 14.0625 9.61313 14.0625H5.625V7.58925H9.61313C9.84769 7.58925 10.0688 7.596 10.2786 7.6095V8.69006C10.1127 8.67452 9.9462 8.66701 9.77962 8.66756H7.12125V12.9836H9.78019C10.8883 12.9836 11.4424 12.7069 11.4424 12.1539V11.3231L11.4418 11.3237Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBos);
export default __webpack_public_path__ + "static/media/bos.4587d294c7cc589b7c3b153f7b2d93c6.svg";
export { ForwardRef as ReactComponent };